import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { subjects } from '../../data/content';
export function PiecesSection() {
  return <Section tone="navy" narrow data-id="element-241" data-mp="3ujszh8yulgww">
      <p className="font-display text-lg font-bold uppercase text-white/70" data-id="element-242" data-mp="3unqk5z12qgiw">The problem isn’t always a lack of knowledge.</p>
      <H2 className="mt-3" data-id="element-243" data-mp="7h6dshopog1d">
        It’s That Implantology Is Often Taught in <span className="text-gold" data-id="element-244" data-mp="7etx07uowbpw">Separate Pieces.</span>
      </H2>
      <p className="mt-6 text-lg text-white/80" data-id="element-245" data-mp="ce6iop9trcqw">Think about it. You study:</p>

      <ul className="mt-5 flex flex-wrap gap-2.5" data-id="element-246" data-mp="h7iutzxbhr2r">
        {subjects.map(s => <li key={s} className="rounded-full border border-line bg-panel px-4 py-2 text-[15px] font-semibold" data-id="element-247" data-mp="m62lgdmuvr1g">
            {s}
          </li>)}
      </ul>

      <div className="mt-8 space-y-3 text-lg leading-relaxed text-white/80" data-id="element-248" data-mp="q5bd9cyc5eud">
        <p data-id="element-249" data-mp="v6il1c0hae11">Each subject is important.</p>
        <p className="text-xl font-bold text-white" data-id="element-250" data-mp="1ftai6culljhz">But a clinical case doesn’t arrive separated into textbook chapters.</p>
        <p data-id="element-251" data-mp="1bqvxdn7dc9o2">All these factors need to be considered together.</p>
      </div>

      <ArrowDownIcon className="mx-auto my-8 h-8 w-8 text-accent" aria-hidden="true" data-id="element-252" data-mp="16slzh4u9euyr" />

      <div className="rounded-2xl bg-accent p-6 text-ink" data-id="element-253" data-mp="11tratm9m2c6q">
        <p className="text-base font-semibold" data-id="element-254" data-mp="11vc4l9o3pr3j">That’s the central idea behind Dental Implant Clinical Roadmap™.</p>
        <p className="mt-2 font-display text-xl font-extrabold leading-snug" data-id="element-255" data-mp="1zjm67njz6cu4">
          A structured reference system that connects the major stages of implant treatment planning.
        </p>
        <p className="mt-3 text-base font-medium" data-id="element-256" data-mp="1ppvod1ict0ne">
          So you can move from disconnected information to a more organized educational planning process.
        </p>
      </div>

      <div className="mt-10" data-id="element-257" data-mp="2i8sqvg4bxeik">
        <CtaButton tone="dark" label="Give me the complete clinical roadmap" note="One-Time Payment of $27 USD" data-id="element-258" data-mp="2i9u5tvogul5k" />
      </div>
    </Section>;
}